import request from '@/utils/request'

let getToken=()=>request.get('/api/token/get')
let regenerateToken=()=>request.get('/api/token/rebuild')

export default {
  getToken,
  regenerateToken
}